import * as Sentry from "@sentry/vue";

export default {
  install(app) {
    const rustWorker = new Worker(
      new URL("/src/worker/rustWorker.js", import.meta.url)
    );

    // Sentry.addIntegration(Sentry.webWorkerIntegration({ worker: rustWorker }));

    rustWorker.onerror = (e) => {
      e.preventDefault();
      if (e.message && e.message.includes("E983457")) {
        // Custom Error Code for fields not calculated: E983457
        const { message, fields } = JSON.parse(e.message.split("Error: ")[1]);
        console.error("Error message:", message, fields);
        Sentry.captureException(message, { extra: fields });
      } else {
        Sentry.captureException(e);
      }
    };
    app.config.globalProperties.$rustWorker = rustWorker;
    app.provide("rustWorker", rustWorker);
  }
};
